import { BROADCAST_SET_SCREEN_ACTIVE } from 'actions/Types';

function setScreenShareActive(isActive) {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_SCREEN_ACTIVE,
      payload: isActive
    };

    dispatch(action);
  };
}

export default setScreenShareActive;
